import React from 'react';
import ReactDOM from 'react-dom/client';
import './hooks/deferredInstallPrompt';
import './index.css';
/* import './assets/fonts/font1.woff2'
import './assets/fonts/font2.woff2'
import './assets/fonts/font3.woff2'
import './assets/fonts/font4.woff2' */

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // {/* </React.StrictMode> */}
);

// Field CWV collection (guide Part 4.1). Values stored on window for debugging.
reportWebVitals((metric) => {
  if (typeof window === 'undefined') return;
  window.__STAR123_VITALS__ = window.__STAR123_VITALS__ || [];
  window.__STAR123_VITALS__.push({
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    id: metric.id,
    navigationType: metric.navigationType,
  });
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log('[CWV]', metric.name, Math.round(metric.value), metric.rating);
  }
});
